import { createBrowserRouter, RouteObject } from 'react-router-dom';
import App from 'App';
import { lazy, Suspense } from 'react';
import PublicRoutes from './PublicRoutes';
import Loading from 'components/common/Loading';
const NotFound = lazy(() => import('../pages/not-found'));
const UnderConstruction = lazy(() => import('../pages/under-construction'));

const SHOW_UNDER_CONSTRUCTION = false;

const routes: RouteObject[] = [
  {
    element: <App />,
    children: SHOW_UNDER_CONSTRUCTION
      ? [
          {
            path: '*',
            element: (
              <Suspense fallback={<Loading />}>
                <UnderConstruction />
              </Suspense>
            ),
          },
        ]
      : [
          PublicRoutes,

          {
            path: '*',
            element: (
              <Suspense fallback={<Loading />}>
                <NotFound />
              </Suspense>
            ),
          },
        ],
  },
];

export const router = createBrowserRouter(routes);

export default routes;
